













































































































































































import { Vue, Component } from 'vue-property-decorator'
import { getPaidOrderList, accessList, getPaymentList, getPaymentAccount, checkOrderStatus } from '@/api/payment/payment'
// import {
//   accessList,
//   getAccessInfo,
//   saveModuleInfo
// } from '@/api/payment/payment'
import { mixins } from 'vue-class-component'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson } from '@/utils/tool'
import DateOption from '@/mixins/dateOption'
@Component({
  name: 'accessModule'
})
export default class extends mixins(DateOption) {
  tableData: any[] = []
  moreOption: string = ''
  multipleSelection: any[] = []
  tableParams: any = {
    page: 1,
    pageCount: 20,
    transaction_no: '',
    app_key: '',
    app_order_sns: '',
    pay_gate_code: undefined,
    pay_status: '',
    pay_config: '',
    ext_order_sn: '',
    createDateStart: '',
    createDateEnd: ''
  }
  totalCount: number = 0
  optionList: any[] = []
  statusList: any[] = [
    {
      value: 'fail',
      label: '未支付'
    },
    {
      value: 'success',
      label: '已支付'
    },
    {
      value: 'refund',
      label: '已退款'
    }
  ]
  paymentList: any[] = []
  accountList: any[] = []

  defaultTime: string[] = ['00:00:00', '23:59:59']
  dateArray: string[] = ['', '']
  tableHeight: number = 500

  selectReverse() {
    const table: any = this.$refs.table
    this.tableData.forEach(row => {
      table.toggleRowSelection(row)
    })
  }

  selectAll() {
    const table: any = this.$refs.table
    this.tableData.forEach(row => {
      if (!this.multipleSelection.includes(row)) table.toggleRowSelection(row)
    })
  }

  async getOptionList() {
    let res: any = await accessList({ page: 1, pageCount: 30 })
    this.optionList = res.data.dataList || []
  }

  async getPaymentOptionList() {
    let res: any = await getPaymentList({ page: 1, pageCount: 30 })
    this.paymentList = res.data.dataList || []
  }

  async getAccountList(id: number) {
    let res: any = await getPaymentAccount({ pay_gate_id: id })
    let dataList: any[] = res.data.dataList
    this.accountList = dataList
    this.tableParams.pay_config = ''
  }

  handleSelectionChange(val: any[]) {
    this.multipleSelection = val
  }

  handlePaymentChange(val: any) {
    let result: any = this.paymentList.find(item => item.code === val)
    this.getAccountList(result.id)
  }

  async handleDateChange(val: string[]) {
    if (val) {
      this.tableParams.createDateStart = val[0]
      this.tableParams.createDateEnd = val[1]
    } else {
      this.tableParams.createDateStart = this.tableParams.createDateEnd = ''
    }
    await this.getTableData()
  }

  handleOption() {}

  async handleCheck({ id }: any) {
    let res: any = await checkOrderStatus({ id })
    console.log(res)
    if (+res.status.code === 0) {
      this.$message.success('操作成功')
    } else {
      this.$message.warning(res.status.message)
    }
  }

  resetParams(refresh: boolean) {
    this.tableParams = {
      page: 1,
      pageCount: 20,
      transaction_no: '',
      app_key: '',
      app_order_sns: '',
      pay_gate_code: undefined,
      pay_status: '',
      pay_config: '',
      ext_order_sn: '',
      createDateStart: '',
      createDateEnd: ''
    }
    this.dateArray = ['', '']
    this.accountList = []
    refresh && this.getTableData()
  }

  async getTableData() {
    this.tableData = []
    let res = await getPaidOrderList(this.tableParams)
    this.tableData = res.data.dataList
    this.totalCount = +res.data.pageInfo.totalCount
  }

  async handleExport() {
    // let params: any = { ...this.tableParams }
    // params.pageCount = 300
    // const res: any = await getPaidOrderList(params)
    let flag:boolean = false
    let list: any[] = []
    for (let key in this.tableParams) {
      if (typeof this.tableParams[key] !== 'number') {
        flag = flag || (!!this.tableParams[key])
      }
    }
    if (flag) {
      list = this.tableData
    } else {
      if (this.multipleSelection.length <= 0) {
        return this.$message.warning('请选择要导出的数据')
      } else {
        list = this.multipleSelection
      }
    }
    const filterVal: string[] = [
      'transaction_no',
      'app_name',
      'app_order_sns',
      'pay_gate_name',
      'pay_config',
      'transaction_no',
      'create_date',
      'pay_amount',
      'pay_status'
    ]
    const theader: string[] = [
      '流水号',
      '接入模块',
      '模块销售订单号',
      '支付平台',
      '支付平台帐号',
      '支付平台流水号',
      '发生时间',
      '支付金额',
      '状态'
    ]
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
    ;(this.$refs['table'] as any).clearSelection()
  }

  get moreOptions() {
    return [
      {
        label: '状态监测',
        value: 'checkStatus'
      }
    ]
  }

  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 280 - filterDom.clientHeight
  }

  created() {
    this.getTableData()
    this.getOptionList()
    this.getPaymentOptionList()
  }

  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
}
